// extracted by mini-css-extract-plugin
module.exports = {"power-independence-H":"H_power-independence-H__cWfGS"};